import React from 'react';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {skills, experiences} from '../constants';
import CTA from './CTA';

function About() {

  const specificSkillNames = (skill) => {
    return skill.name == 'Blockchain' || skill.name == 'GCP';
  }

  return (
    <section className='pt-24 mx-8 select-none'>
      <h1 className='font-bold text-3xl mb-6 text-indigo-900'>Hello, I'm <span className='text-semibold drop-shadow gradient-text shadow-sm tracking-widest'>Ahmed Imran</span></h1>
      <div className='mb-10'> 
        <p className='text-xl tracking-wider font-semibold text-zinc-500 antialiased text-justify'>
          Software Engineer based in Pakistan, with solid foundation in Web Development. Additionally, I possess introductory
          knowledge of blockchain and Solidity. Eager to contribute to innovative projects, I am a quick learner with 
          a passion for staying updated on industry trends and continuously expanding my skill set.
        </p>
      </div>
      <div className='py-10 flex flex-col'>
        <h3 className='font-bold text-2xl tracking-wide'>My Skills</h3>
        <div className='mt-16 grid sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-10 gap-12 mx-auto'>
          {skills.map(skill => (
            <div className="w-20 h-20 flex">
              <div className='flex items-center justify-center'>
                <img src={skill.imageUrl} alt={skill.name} className={`${specificSkillNames(skill) ? 'w-5/6 h-5/6 object-contain'  : 'object-contain'}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='py-16 select-none'>
            <h3 className='font-bold text-2xl tracking-wide'>Work Experience</h3>
            <p className='text-xl tracking-wide font-semibold text-zinc-500 antialiased mt-8 mb-24'>I have worked with some companies, 
              leveling up my skills and teaming up with smart people. Here is the rundown:
            </p>
            <VerticalTimeline>
              {experiences.map(experience => (
                <VerticalTimelineElement
                  key={experience.company_name}
                  date={experience.date}
                  icon={
                    <div className='flex items-center justify-center w-full h-full select-none'>
                      <img src={experience.icon} alt={experience.company_name} className='w-[60%] h-[60%] object-contain'/>
                    </div>
                  }
                  contentStyle={{
                    borderBottom:'8px',
                    borderStyle:'solid',
                    borderBottomColor:experience.iconBg,
                    boxShadow:'none'
                  }}

                  iconStyle={{
                    borderBottom:'8px',
                    borderStyle:'solid',
                    borderBottomColor:experience.iconBg,
                    boxShadow:'none',

                  }}
                >
                  <div>
                    <h3 className="font-bold text-lg text-black tracking-wide">{experience.title}</h3>
                    <p className='text-black-500 font-medium'> {experience.company_name}</p>
                    <ul className='my-5 ml-5 space-y-2 list-disc tracking-wide'>
                      {experience.points.map((point, idx) => (
                        <li key={idx} className='text-black-500/50 pl-1 text-sm'>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                    
                </VerticalTimelineElement>

              ))}
            </VerticalTimeline>
      </div>
      <hr className='border-slate-200' />
      <CTA />
    </section>
  )
}

export default About;